import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { UserManagementService } from '../../../../../../services/user-management.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CtaAction } from '../../../../../../models/cta.action';
import { CurrentDataService } from '../../../../../../services/current-data-service';
import { BaryModalService } from '../../../../../../services/bary-modal.service';
import { User } from '../../../../../../models/user.model';

export enum LIST_ACTIONS_USER {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  TEST = 'TEST',
}

@Component({
  selector: 'jhi-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
})
export class UsersListComponent {
  readonly #translateService = inject(TranslateService);
  readonly #currentDataService = inject(CurrentDataService);
  readonly #userService = inject(UserManagementService);
  @Input() users: User[] = [];
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();
  PATHS = PATHS;
  currentAccount?: User;
  ctaActions: CtaAction[] = [
    {
      label: this.#translateService.instant('cta-user-action.labels.view'),
      action: LIST_ACTIONS_USER.VIEW,
      tooltip: this.#translateService.instant('cta-user-action.tooltips.view'),
    },
    {
      label: this.#translateService.instant('cta-user-action.labels.edit'),
      action: LIST_ACTIONS_USER.EDIT,
      tooltip: this.#translateService.instant('cta-user-action.tooltips.edit'),
    },
  ];

  constructor(private modalService: BaryModalService, private router: Router) {
    this.#currentDataService.getAccount().subscribe(account => (this.currentAccount = account));
  }

  trackId(index: number, item: User): number {
    return item.id!;
  }

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  setActive(user: User, isActivated: boolean): void {
    this.#userService.update({ ...user, activated: isActivated } as any).subscribe(() => this.transition());
  }

  public onSelectAction(cta: CtaAction, user: User): void {
    switch (cta.action) {
      case LIST_ACTIONS_USER.VIEW:
        this.router.navigateByUrl(PATHS.ADMIN_USER_MANAGEMENT_LOGIN_VIEW.withLogin(user.login));
        break;
      case LIST_ACTIONS_USER.EDIT:
        this.router.navigateByUrl(PATHS.ADMIN_USER_MANAGEMENT_LOGIN_EDIT.withLogin(user.login));
        break;
    }
  }
}
